import React from "react";
import { Provider } from "react-redux";

// third party
// import { createRoot } from "react-dom/client";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import "./assets/css/index.css";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";
import { store } from "features";

// react 17.x
const root = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        {/* <BrowserRouter basename="/ok"> */}
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  root
);

// react 18.x
// const container = document.getElementById("root");
// const root = createRoot(container);

// root.render(
//   // <React.StrictMode>
//   <Provider store={store}>
//     <BrowserRouter>
//       {/* <BrowserRouter basename="/ok"> */}
//       <App />
//     </BrowserRouter>
//   </Provider>
//   // </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
